import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
const Talentmangementmenu = () => {
 
  return (
    <div > 
      
     <Navbar style={{backgroundColor:"#2F9DCC"}} className='d-flex justify-content-left'>
    
          <Nav>
            <Nav.Link as={Link} to="/Dashboard" className='text-white'>Home</Nav.Link>
             <Nav.Link as={Link} to="/Agents" className='text-white'>Agents</Nav.Link>
            <Nav.Link as={Link} to="/Customers" className='text-white'>Customers </Nav.Link>
            <Nav.Link as={Link} to="/Staff" className='text-white'>Staff</Nav.Link>
            <Nav.Link as={Link} to="/Insurancecarriers" className='text-white'>Carriers</Nav.Link>
            <Nav.Link as={Link} to="/Appointments" className='text-white'>Appointment</Nav.Link>
            <Nav.Link as={Link} to="/Requestacall" className='text-white'>Request a call</Nav.Link>
          </Nav>
          </Navbar>
    
    </div>
  )
}

export default Talentmangementmenu
